import { reactive, ref, unref, computed } from 'vue'
import _lodash from 'lodash'
import { type BMapItemType } from '../components/BMapItems/interface'

export const useZnMap = () => {
  let instance: any = null
  let map: any = null //百度地图
  const znMapInstance = ref(null)
  const register = (m, i) => {
    console.log('register', m, i)
    map = m
    instance = i
    znMapInstance.value = new ZnMapInstance(m, i)
  }
  const getMap = () => {
    return map
  }
  const getInstance = () => {
    return instance
  }

  const getZnMapInstance = () => {
    return znMapInstance.value
  }

  const overlayList = computed(() => {
    return znMapInstance.value?.state?.overlayList ?? []
  })
  return {
    getMap,
    getInstance,
    register,
    getZnMapInstance,
    znMapInstance,
    overlayList
  }
}

export class ZnMapInstance {
  /** 百度地图 */
  map: any
  /** Bmap实例 */
  instance: any
  /** BMap */
  bmap: any
  state: any = reactive({
    overlayList: []
  })

  constructor(map: any, instance: any, bmap?: any) {
    this.map = map
    this.instance = instance
    this.bmap = bmap
  }

  /**
   * @description: 添加覆盖物，可传List,可传官方例子中的属性https://yue1123.github.io/vue3-baidu-map-gl/    可以在对象中增加"tag"属性，增加后可以使用removeByTag方法删除
   */
  add(item: BMapItemType | Array<BMapItemType>) {
    if (_lodash.isArray(item)) {
      this.state.overlayList.push(...item)
    } else {
      this.state.overlayList.push(item)
    }
  }
  /**
   * @description: 去除覆盖物
   */
  remove(item: BMapItemType | Array<BMapItemType>) {
    if (_lodash.isArray(item)) {
      item.forEach((_item) => {
        _lodash.remove(this.state.overlayList, (_) => _lodash.isEqual(_, _item))
      })
    } else {
      _lodash.remove(this.state.overlayList, (_) => _lodash.isEqual(_, item))
    }
  }

  /**
   * @description: 根据tag删除覆盖物
   */
  removeByTag(tag: string) {
    _lodash.remove(this.state.overlayList, (_) => _.tag === tag)
  }

  clear() {
    this.state.overlayList = []
  }
}
